import React from 'react';
import { motion } from 'framer-motion';
import { processSteps } from '../data/mock';
import { CheckCircle2 } from 'lucide-react';

const ProcessSection = () => {
  return (
    <section id="process" className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="badge-minimal mb-6">Our Process</span>
          <h2 className="title-minimal mb-4">
            Guiding You From Concept to <span className="title-accent">Certification</span>
          </h2>
          <p className="text-base text-[#4A4A5A] max-w-2xl mx-auto">
            Our proven 5-step process ensures your cleanroom project is delivered 
            on time, on budget, and to specification.
          </p>
        </motion.div>

        {/* Steps */}
        <div className="space-y-4">
          {processSteps.map((step, index) => (
            <motion.div
              key={step.step}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="card-minimal overflow-hidden hover:border-[#1C4B8A]/30"
            >
              <div className="flex flex-col md:flex-row">
                {/* Number */}
                <div className="flex items-center justify-center p-6 md:p-10 md:w-44 bg-[#FAFBFC] border-b md:border-b-0 md:border-r border-[#E5E7EB]">
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-[#1C4B8A] flex items-center justify-center shadow-lg">
                    <span className="text-2xl md:text-3xl font-bold text-white">{step.step}</span>
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 p-6 md:p-8">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="px-3 py-1 text-xs font-semibold text-white bg-[#1C4B8A] rounded">
                      Step {step.step}
                    </span>
                    <span className="text-sm text-[#8A8A9A]">{step.duration}</span>
                  </div>
                  
                  <h3 className="text-xl font-semibold text-[#1A1A2E] mb-3">{step.title}</h3>
                  <p className="text-sm text-[#4A4A5A] mb-5 leading-relaxed">{step.description}</p>
                  
                  <div className="flex flex-wrap gap-2">
                    {step.deliverables.map((item, i) => (
                      <span
                        key={i}
                        className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-[#1C4B8A] bg-[#1C4B8A]/5 rounded"
                      >
                        <CheckCircle2 className="w-3.5 h-3.5" />
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
